import React from 'react';
import PropTypes from 'prop-types';
import './Modal.css';

/* MODAL V2 */
function ModalCTA({
  id, title, classTitle, description, styleContainer, classModal, styleModal, styleBody, styleDescription, styleGroupCta,
  ctaFlexDirection = 'flexColumn', cancelClick, modalHasEntered, children, icon = null
}) {
  const extra = { cancelClick, modalHasEntered };
  return (
    <div id={id} className={`flexColumn cta`} style={styleContainer}>
      <div className={`flexColumn modalV2 ${classModal}`} style={styleModal}>
        <div className={`flexColumn body`} style={styleBody}>
          { icon && icon }
          <div className={`title ${classTitle}`}>{title}</div>
          {description && <div className={`description`} style={styleDescription}>{description}</div>}
          <div className={`${ctaFlexDirection} group-cta`} style={styleGroupCta}>
            { React.Children.map(children, child => (React.isValidElement(child)) && React.cloneElement(child, extra)) }
          </div>
        </div>
      </div>
    </div>
  )
}

ModalCTA.propTypes = {
  title: PropTypes.string.isRequired,
  description: PropTypes.string,
  styleContainer: PropTypes.object,
  styleModal: PropTypes.object,
  classModal: PropTypes.string,
  styleBody: PropTypes.object,
  styleGroupCta: PropTypes.object,
  styleDescription: PropTypes.object,
  ctaFlexDirection: PropTypes.string,
  cancelClick: PropTypes.func,
  modalHasEntered: PropTypes.any
}

export default ModalCTA;
